import React from 'react';
import { ReactComponent as GraphicBase } from '~/assets/images/calc-graphic-base.svg';
import { ReactComponent as GraphicTop } from '~/assets/images/calc-graphic-top.svg';
import { useCalculateMaximumMortgageForm } from '~/pages/Tools/CalculateMaximumMortgage/Calculate/context/FormProvider';
import { useWatch } from 'react-hook-form';

const NoCalculationMessage: React.FC = () => {
  const { control } = useCalculateMaximumMortgageForm();

  const hasPartner = useWatch({
    control,
    name: 'hasPartner',
    defaultValue: false,
  });

  return (
    <div>
      <h2 className="relative z-20 text-black font-display text-2xl mb-4">Indicatie maximale hypotheek</h2>
      <p className="text-stone-700 text-balance mb-0">
        Vul alle gegevens zo compleet mogelijk in om een indicatie te krijgen van {hasPartner ? 'jullie' : 'jouw'} maximale hypotheek.
      </p>
      <div className="-my-6">
        <div className="mx-auto lg:w-8/12 relative">
          <GraphicBase className="relative h-auto w-full fill-stone-500" />
          <GraphicTop className="absolute top-0 left-0 h-full w-full fill-blue-500" />
        </div>
      </div>
    </div>
  );
};

export default NoCalculationMessage;